module.exports = __webpack_public_path__ + "static/logos-dc669adc67cc466651b26feddf7b9da7.svg";